import React, { createContext, useState, useEffect, useRef } from "react";
import { SidoSiggService } from "../services/SidoSiggService";

export const SidoSiggContext = createContext();

export const SidoSiggProvider = ({ children }) => {
  const [sidos, setSidos] = useState([]);
  const [siggs, setSiggs] = useState([]);
  const [sido, setSido] = useState("");
  const prevSidoRef = useRef(sido);

  useEffect(() => {
    SidoSiggService.fetchSidos()
        .then(setSidos)
        .catch(error => console.error("Error fetching sidos:", error));
}, []);

  useEffect(() => {
    if (sido && prevSidoRef.current !== sido) {  // sido가 존재할 때만 fetchSiggs 실행
      SidoSiggService.fetchSiggs(sido)
        .then(setSiggs)
        .catch(error => console.error("Error fetching siggs:", error));
      prevSidoRef.current = sido;
    } else {
      setSiggs([]); // sido가 없을 때 siggs 초기화
    }
  }, [sido]);

  const fetchSiggs = async (sidoId) => {
    const data = await SidoSiggService.fetchSiggs(sidoId);
    setSiggs(data);
  };

  return (
    <SidoSiggContext.Provider value={{ sidos, siggs, sido, setSido, fetchSiggs }}>
      {children}
    </SidoSiggContext.Provider>
  );
};
